import { useWorkspaceContext } from './WorkspaceContext';

export function useWorkspace(context: string) {
  const ctx = useWorkspaceContext();
  return {
    isVisible: (id: string) => ctx.isVisible(context, id),
    toggle: (id: string) => ctx.toggle(context, id),
    getPinnedOrder: () => ctx.getPinnedOrder(context),
    setPinnedOrder: (order: string[]) => ctx.setPinnedOrder(context, order),
    hiddenCount: ctx.hiddenCount(context),
    ready: ctx.ready,
  };
}
